// app/javascript/controllers/phone_controller.js
import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input/intlTelInputWithUtils"

// Connects to data-controller="phone"
export default class extends Controller {
  static targets = ["input", "hiddenInput"]

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      initialCountry: "gh",
      separateDialCode: true
    })

    this.form = this.element.closest("form")

    if (this.form) {
      this.submitHandler = this.syncFullPhoneNumber.bind(this)
      this.form.addEventListener("submit", this.submitHandler)
    }
  }

  disconnect() {
    this.iti?.destroy()

    if (this.form && this.submitHandler) {
      this.form.removeEventListener("submit", this.submitHandler)
    }
  }

  syncFullPhoneNumber(event) {
    if (this.iti.isValidNumber()) {
      this.hiddenInputTarget.value = this.iti.getNumber()
    } else {
      event.preventDefault()
      alert("Please enter a valid phone number.")
    }
  }
}